import { Dispatch } from 'react';
import { CacheDataActions, CacheDataState } from '../types/CacheDataContext';
import { CommonDataStateType } from './type';

export const commonDataState: CommonDataStateType = {
	conversionUnit: 'PB',
};

export const commonDataReducer = (state: CacheDataState, action: CacheDataActions): CacheDataState => {
	if (action.type === 'CONV_UNIT') {
		return { ...state, conversionUnit: action.value };
	}

	return state;
};

// Action creators
export const setCurrentConversionUnit = (
	dispatch: Dispatch<CacheDataActions>,
	value: CacheDataState['conversionUnit']
) => dispatch({ type: 'CONV_UNIT', value });
